import { AudioPlayerHandler } from './audioPlayerHandler';
import { Logger, LogManager } from '../logger/logger';
import { AudioPlayer} from './audioplayerImpl';

export interface PlayerManager
{
    setPlayerHandler(playerHandler: PlayerHandler): void;
    startPlay(url: string, playerHandler: PlayerHandler): void;
   // setSeekbar(seekBar: HTMLInputElement): void;
   // changeCurrentTime(): void;
    stopPlay(): void;
    release(): void;
    getAudioPlayer() : AudioPlayer;
    //setStartTimeRef(startTime: HTMLLabelElement): void;
    //setEndTimeRef(endTime: HTMLLabelElement): void;
}

export interface PlayerHandler
{
   onPlayComplete(): void;
   onPlayStop(): void;
}

export class PlayerManagerImpl implements AudioPlayerHandler, PlayerManager
{
    private logger: Logger = LogManager.getLogger(PlayerManagerImpl.name);
    private playerHandler: PlayerHandler | undefined;
   // private startTimeRef: HTMLLabelElement;
   // private endTimeRef: HTMLLabelElement;

    constructor(private audioPlayer: AudioPlayer)
    {
        this.audioPlayer.setAudioPlayerHandler(this);

       // this.changeCurrentTime = this.changeCurrentTime.bind(this);
    }

    getAudioPlayer() : AudioPlayer
    {
       return this.audioPlayer;
    }

    startPlay(url: string, playerHandler: PlayerHandler): void 
    {
        this.logger.log("StartPlay() Invoked: MediaURL: " + url);
        this.logger.log("Previous Handler: " + this.playerHandler + ", New Handler: " + playerHandler);
        this.logger.log("Is Handler Same: " + (this.playerHandler === playerHandler));
        try
        {
            if(playerHandler !== this.playerHandler)
            {
                if(this.playerHandler !== undefined)
                {
                    this.playerHandler.onPlayStop();
                }
                
                this.setPlayerHandler(playerHandler);
                this.audioPlayer.playURL(url);
            }
            else
            {
                this.audioPlayer.play();
            }
        }
        catch(e)
        {
            this.logger.error(e.message);
     
            this.playerHandler !== undefined && this.playerHandler.onPlayStop();
        }
    }

    setPlayerHandler(playerHandler: PlayerHandler): void
    {
        this.playerHandler = playerHandler;
    }

    onPlayComplete(): void 
    {
        this.logger.log("onPlayComplete() invoked");

        this.playerHandler !== undefined && this.playerHandler.onPlayComplete();
    }

    onPlayError(): void 
    {
        this.logger.log("onPlayError() invoked");

        this.playerHandler !== undefined && this.playerHandler.onPlayStop();
    }

    stopPlay(): void 
    {
        this.audioPlayer.stop();
    }

    release(): void 
    {
       // console.log("-----release() invoked");
        this.audioPlayer.stop();
        this.playerHandler = undefined;
    }

   /*  setSeekbar(seekBar: HTMLInputElement)
    {
       (this.audioPlayer as AudioPlayerImpl).setSeekbar(seekBar);
    } */
  
    /* changeCurrentTime(): void {
        (this.audioPlayer as AudioPlayerImpl).changeCurrentTime();
    } */

    /* setStartTimeRef(startTime: HTMLLabelElement): void {
       this.startTimeRef = startTime;
    } */
   /*  setEndTimeRef(endTime: HTMLLabelElement): void {
       this.endTimeRef = endTime;
    } */

   /*  updateStartTime(startTime: string): void 
    {
        if(this.startTimeRef !== null)
        {
            this.startTimeRef.innerHTML = startTime;
        }
    } */
    /* updateEndTime(endTime: string): void 
    {
        if(this.endTimeRef !== null)
        {
            this.endTimeRef.innerHTML = endTime;
        }
    } */
}








// this.playManager.setPlayListData(this.getAudioFiles());
// this.playManager.startPlay();
// this.playManager.setOnPlayListCompletedCallback(() =>
// {
//      this.triggerProcessCompletedEvent(this.SUCCESS_ACCESS_TYPE);
// });

// this.playManager.setOnPlayListErrorCallback(() =>
// {
//      this.triggerProcessCompletedEvent(this.FAILURE_ACCESS_TYPE);
// });

// this.playManager.getCurrentPlayingPrompt((prompt: string) =>
// {
//     this.addInfoEmulatorLog("Current Playing Prompt: " + prompt);

//     this.updateVariableItemData(VariableId.CURRENT_PROMPT, prompt);//Updating current playing prompt to CURRENT_PROMPT Variable
// });
// }



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/player/playmanager.ts